module.exports = window.initializeRemote('app_am_activities', {"WEBPACK_BUNDLE":true,"WEBPACK_BUILD":true,"BUILD_TARGET":"production"});